<template>
  <div class="animated fadeIn">
    <b-modal ref="modal-ajuizamento" scrollable centered button-size="sm">
      <template #modal-title>
      <i class="fas fa-map-marker-alt"></i> {{ ajuizamento ? 'EDITAR AJUIZAMENTO' : 'NOVO AJUIZAMENTO' }}
      </template>
      <div class="form-group row pt-2">
        <div class="col-md-12 pb-2" v-if="ajuizamento">
          <label><small class="text-danger">*</small> CNJ:</label>
          <div class="input-group">
            <b-form-input type="text"
              v-model="form.cnj.value"
              :required="form.cnj.required"
              :state="form.cnj.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-12 pb-2">
          <label><small class="text-danger">*</small> Número Processo:</label>
          <div class="input-group">
            <b-form-input type="text"
              v-model="form.numeroProcesso.value"
              :required="form.numeroProcesso.required"
              :state="form.numeroProcesso.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-12 pb-2">
          <label for="txtName"><small class="text-danger">*</small> Assunto:</label>
          <div class="input-group">
            <b-form-select v-model="form.assuntoId.value" :options="form.assuntoId.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-12 pb-2">
          <label for="txtName"><small class="text-danger">*</small> Objeto Ação:</label>
          <div class="input-group">
            <b-form-select v-model="form.objetoAcaoId.value" :options="form.objetoAcaoId.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-12 pb-2">
          <label for="txtName"><small class="text-danger">*</small> Comarca:</label>
          <div class="input-group">
            <b-form-select v-model="form.comarcaId.value" :options="form.comarcaId.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-12 pb-2">
          <label for="txtName"><small class="text-danger">*</small> Prognostico:</label>
          <div class="input-group">
            <b-form-select v-model="form.prognosticoId.value" :options="form.prognosticoId.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-12 pb-2">
          <label for="txtName"><small class="text-danger">*</small> Fase:</label>
          <div class="input-group">
            <b-form-select v-model="form.faseId.value" :options="form.faseId.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-12 pb-2">
          <label><small class="text-danger">*</small> Advogado Responsável:</label>
          <div class="input-group">
            <b-form-input type="text"
              v-model="form.advogadoResponsavel.value"
              :required="form.advogadoResponsavel.required"
              :state="form.advogadoResponsavel.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-12 pb-2">
          <label>Advogado Contrário:</label>
          <div class="input-group">
            <b-form-input type="text"
              v-model="form.advogadoContrario.value"
              :required="form.advogadoContrario.required"
              :state="form.advogadoContrario.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-12 pb-2">
          <label><small class="text-danger">*</small> Valor Causa:</label>
          <div class="input-group">
            <b-form-input type="number"
              v-model="form.valorCausa.value"
              :required="form.valorCausa.required"
              :state="form.valorCausa.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-12 pb-2">
          <label> Valor Causa 2:</label>
          <div class="input-group">
            <b-form-input type="number"
              v-model="form.valorCausa2.value"
              :required="form.valorCausa2.required"
              :state="form.valorCausa2.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-12 pb-2">
          <label><small class="text-danger">*</small> Data Distribuição:</label>
          <div class="input-group">
            <b-form-input type="date"
              v-model="form.dataDistribuicao.value"
              :required="form.dataDistribuicao.required"
              :state="form.dataDistribuicao.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-12 pb-2">
          <label><small class="text-danger">*</small> Último Andamento:</label>
          <div class="input-group">
            <b-form-input type="date"
              v-model="form.ultimoAndamento.value"
              :required="form.ultimoAndamento.required"
              :state="form.ultimoAndamento.state"></b-form-input>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button @click.prevent="!ajuizamento ? onSave() : onUpdate()"
                  type="button"
                  class="btn btn-third btn-sm"
                  v-b-tooltip.hover
                  :title="!ajuizamento ? 'Salvar' : 'Atualizar'">
            <i class="fas fa-check-circle"></i>
            <span class="d-md-down-none"> {{!ajuizamento ? 'Salvar' : 'Atualizar'}}</span>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import AjuizamentoModal from './ajuizamentoModal.js'
export default AjuizamentoModal
</script>
./AjuizamentoModal.js



// WEBPACK FOOTER //
// src/views/private/crm/details/ajuizamento/modal/AjuizamentoModal.vue